import api from './api';

export const changeStatusApprover = async (formData) => {
    try {
        const response = await api.put('/api/overtime/changeStatusApprover', formData);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const getSingleItem = async (itemId) => {
    try {
        const response = await api.get(`/api/overtime/getSingleItem/${itemId}`);
        return response.data;
    } catch (error) {
        return null;
    }
};

export const updatePayment = async (obj) => {
    try {
        const response = await api.put('/api/overtime/updatePayment', obj);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const deleteRequest = async (id) => {
    try {
        const response = await api.delete(`/api/overtime/deleteRequest/${id}`);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const getRequestsByUserId = async (userId, registersQty) => {
    try {
        const response = await api.get(`/api/overtime/getRequestsByUserId/${userId}/${registersQty}`);
        return response.data;
    } catch (error) {
        return { result: false, requests: [] };
    }
};

export const getItemsByRequestId = async (requestId) => {
    try {
        const response = await api.get(`/api/overtime/getItemsByRequestId/${requestId}`);
        return response.data;
    } catch (error) {
        return { regularItems: [], formattedExtraPayments: [] };
    }
};

export const deleteItem = async (itemId) => {
    try {
        const response = await api.delete(`/api/overtime/deleteItem/${itemId}`);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const getMovementsByRequestId = async (requestId) => {
    try {
        const response = await api.get(`/api/overtime/getMovementsByRequestId/${requestId}`);
        return response.data;
    } catch (error) {
        return [];
    }
};

export const addUser = async ({ email, userName, roleId, approver1, approver2, otHourCost, weeklyPayment }) => {
    try {
        const response = await api.post('/api/users/addUser', {
            email,
            userName,
            roleId,
            approver1,
            approver2,
            otHourCost,
            weeklyPayment
        });
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const getRoles = async () => {
    try {
        const response = await api.get('/api/generalQueries/getRoles');
        return response.data;
    } catch (error) {
        return [];
    }
};

export const getApproversAndAdmins = async () => {
    try {
        const response = await api.get('/api/users/getApproversAndAdmins');
        return response.data;
    } catch (error) {
        return [];
    }
};

export const getRequestsByDatesAndStatusId = async (statusId, selectedDate) => {
    try {
        const response = await api.post('/api/overtime/getRequestsByDatesAndStartsId', { statusId, selectedDate });
        return response.data;
    } catch (error) {
        return { requests: [], totalHours: 0, totalToPay: 0 };
    }
};

export const getActiveStatus = async () => {
    try {
        const response = await api.get('/api/generalQueries/getActiveStatus');
        return response.data;
    } catch (error) {
        return [];
    }
};

export const inactivateUser = async (id) => {
    try {
        const response = await api.put(`/api/users/inactivateUser/${id}`);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const activateUser = async (id) => {
    try {
        const response = await api.put(`/api/users/activateUser/${id}`);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const getAllUsers = async () => {
    try {
        const response = await api.get('/api/users/getAll');
        return response.data;
    } catch (error) {
        return [];
    }
};

export const getUserToEdit = async (id) => {
    try {
        const response = await api.get(`/api/users/getUserToEdit/${id}`);
        return response.data;
    } catch (error) {
        return {};
    }
};

export const updateUser = async ({ id, email, userName, roleId, approver1, approver2, otHourCost, weeklyPayment }) => {
    try {
        const response = await api.put('/api/users/updateUser', {
            id,
            email,
            userName,
            roleId,
            approver1,
            approver2,
            otHourCost,
            weeklyPayment
        });
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const requestRecoverPassword = async (email) => {
    try {
        const response = await api.post('/api/auth/resetPassword', { email });
        return response.data;
    } catch (error) {
        return { result: false, msg: 'Error al solicitar el reinicio de contraseña.' };
    }
};

export const getPendingRequests = async (userId, roleId) => {
    try {
        const response = await api.get(`/api/overtime/getPendingPequests/${userId}/${roleId}`);
        return response.data;
    } catch (error) {
        return [];
    }
};

export const updatePassword = async (id, pwd) => {
    try {
        const response = await api.put('/api/auth/updatePassword', { id: parseInt(id), pwd });
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const checkIfHasARequest = async (id) => {
    try {
        const response = await api.get(`/api/auth/checkIfUserHasAPwdRequest/${id}`);
        return response.data.result;
    } catch (error) {
        return false;
    }
};